import { createContext, useContext } from 'react';

import { OpenSnackbarParams, Positions, SnackbarValue, SnackType } from './snackbar.types';

// Snackbar default values
export const defaultPosition: Positions = 'bottom-center';
export const defaultDuration = 5000;
export const defaultInterval = 250;
export const positions: Positions[] = [
  'top-left',
  'top-center',
  'top-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
];
export const defaultSnackType: SnackType = 'standard';

export const SnackbarContext = createContext<SnackbarValue>({
  openSnackbar: () => {
    return;
  },
  closeSnackbar: () => {
    return;
  },
});

// Custom hook to trigger the snackbar on function components
export const useSnackbar = (): [SnackbarValue['openSnackbar'], SnackbarValue['closeSnackbar']] => {
  const { openSnackbar, closeSnackbar } = useContext(SnackbarContext);

  // Returns methods in hooks array way
  return [openSnackbar, closeSnackbar];
};
